import {AddDrawingComponent} from '@presentation/pages/texedit/drawing-library/add/drawing/add-drawing.component';
import {Observable, Observer} from 'rxjs';

export const canLeaveAddDrawingsGuard = (component: AddDrawingComponent): Observable<boolean> | boolean => {
  component.skipDuplication = true;

  return new Observable((observer: Observer<boolean>) => {
    observer.next(true);
    observer.complete();
  });
};
